import React from 'react';
import { Facebook, Linkedin, Twitter, Instagram, Youtube, Shield, Lock, CreditCard, CheckCircle, Download, Chrome, Apple, Smartphone } from 'lucide-react';

export default function KevalFooter() {
  return (
    <footer className="bg-white border-t border-gray-200">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Get Support */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-base">Get support</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Help Center</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Live chat</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Check order status</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Refunds</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Report abuse</a></li>
            </ul>
          </div>

          {/* Payments and Protections */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-base">Payments and protections</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Safe and easy payments</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Money-back policy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">On-time shipping</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm underline">After-sales protections</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Product monitoring services</a></li>
            </ul>
          </div>

          {/* Source on Keval.com */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-base">Source on crossdealglobal.com</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Request for Quotation</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Membership program</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Sales tax and VAT</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Keval.com Reads</a></li>
            </ul>
          </div>

          {/* Sell on Keval.com */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-base">Sell on Crossdealglobal.com</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Start selling</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Seller Central</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Become a Verified Supplier</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Partnerships</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Download the app for suppliers</a></li>
            </ul>
          </div>

          {/* Get to Know Us */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4 text-base">Get to know us</h3>
            <ul className="space-y-3 mb-6">
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">About crossdealglobal.com</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Corporate responsibility</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">News center</a></li>
              <li><a href="#" className="text-gray-600 hover:text-orange-600 text-sm">Careers</a></li>
            </ul>
            
            <h4 className="font-semibold text-gray-900 mb-3 text-base">Stay Connected</h4>
            <div className="flex gap-3 flex-wrap">
              <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors">
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Payment Icons */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          {/* Security Badges */}
          {/* <div className="flex flex-wrap items-center gap-3 mb-6">
            <div className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg bg-white shadow-sm hover:shadow-md transition">
              <Shield size={16} className="text-orange-500" />
              <span className="text-xs font-semibold text-gray-700">ID Verified</span>
            </div>
            
            <div className="flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg hover:shadow-md transition">
              <Lock size={14} className="text-green-600" />
              <span className="text-xs font-semibold text-green-700">SSL Secure</span>
            </div>
            
            <div className="flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-lg hover:shadow-md transition">
              <CheckCircle size={14} className="text-blue-600" />
              <span className="text-xs font-semibold text-blue-700">Verified</span>
            </div>

            <div className="flex items-center gap-2 px-3 py-2 bg-purple-50 border border-purple-200 rounded-lg hover:shadow-md transition">
              <CreditCard size={14} className="text-purple-600" />
              <span className="text-xs font-semibold text-purple-700">Secure Payment</span>
            </div>
          </div> */}

          {/* Payment Methods with Real Icons */}
          <div className="flex flex-wrap items-center gap-3">
            {/* Visa */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-5" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.5 1.5L15.5 14.5H12L15 1.5H18.5Z" fill="#1A1F71"/>
                <path d="M30.5 1.7C29.8 1.4 28.6 1 27 1C23.5 1 21 2.8 21 5.5C21 7.5 23 8.6 24.5 9.3C26 10 26.5 10.5 26.5 11.1C26.5 12.1 25.3 12.5 24.2 12.5C22.6 12.5 21.7 12.3 20.4 11.7L19.9 11.5L19.4 14.3C20.2 14.7 21.7 15 23.3 15C27 15 29.3 13.2 29.4 10.4C29.4 8.8 28.3 7.6 26 6.5C24.6 5.8 23.8 5.4 23.8 4.7C23.8 4.1 24.5 3.4 26.1 3.4C27.4 3.4 28.3 3.6 29 4L29.4 4.2L29.9 1.5L30.5 1.7Z" fill="#1A1F71"/>
                <path d="M35.5 1.5C34.8 1.5 34.2 1.6 33.9 2.3L28.5 14.5H32.2L33 12.1H37.5L38 14.5H41.2L38.5 1.5H35.5ZM34.2 9.5L35.9 4.8L36.9 9.5H34.2Z" fill="#1A1F71"/>
                <path d="M10.5 1.5L7 10.8L6.6 8.9L5.3 3C5.1 2.2 4.5 1.5 3.6 1.5H0.1L0 2C1.5 2.3 2.8 2.8 4 3.4L7.1 14.5H10.9L16.5 1.5H12.8H10.5Z" fill="#1A1F71"/>
              </svg>
            </div>

            {/* Mastercard */}
            <div className="h-8 px-3 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-6" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="12" r="10" fill="#EB001B"/>
                <circle cx="25" cy="12" r="10" fill="#F79E1B"/>
                <path d="M20 6C18 7.8 16.8 10.2 16.8 13C16.8 15.8 18 18.2 20 20C22 18.2 23.2 15.8 23.2 13C23.2 10.2 22 7.8 20 6Z" fill="#FF5F00"/>
              </svg>
            </div>

            {/* American Express */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-4" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="16" rx="2" fill="#006FCF"/>
                <text x="24" y="11" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">AMEX</text>
              </svg>
            </div>

            {/* PayPal */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-5" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 3C18 3 20.5 3 21.5 3C23.5 3 25 4.2 25 6.3C25 8.4 23.5 9.6 21.5 9.6H19L18 3Z" fill="#003087"/>
                <path d="M16.5 4L15 12H17.5L18.5 7.5H20.2C22 7.5 23.3 6.3 23.3 4.5C23.3 2.7 22 1.8 20.2 1.8H16.8L16.5 4Z" fill="#009CDE"/>
                <path d="M13.5 5L12 13H14.5L15.5 8.5H17.2C19 8.5 20.3 7.3 20.3 5.5C20.3 3.7 19 2.8 17.2 2.8H13.8L13.5 5Z" fill="#012169"/>
              </svg>
            </div>

            {/* Apple Pay */}
            <div className="h-8 px-4 flex items-center justify-center bg-black rounded-md shadow-sm hover:shadow-md transition">
              <Apple size={16} className="text-white mr-1" />
              <span className="text-white text-xs font-medium">Pay</span>
            </div>

            {/* Google Pay */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-6" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <text x="2" y="11" fill="#5F6368" fontSize="8" fontWeight="600">G Pay</text>
                <circle cx="1" cy="8" r="2" fill="#EA4335"/>
                <circle cx="4" cy="8" r="2" fill="#FBBC04"/>
                <circle cx="7" cy="8" r="2" fill="#34A853"/>
                <circle cx="10" cy="8" r="2" fill="#4285F4"/>
              </svg>
            </div>

            {/* Discover */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-4" viewBox="0 0 48 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="14" rx="2" fill="#FF6000"/>
                <text x="4" y="10" fill="white" fontSize="7" fontWeight="bold">DISCOVER</text>
              </svg>
            </div>

            {/* UPI */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-5" viewBox="0 0 36 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="16" rx="2" fill="#097939"/>
                <text x="18" y="11" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold">UPI</text>
              </svg>
            </div>

            {/* Paytm */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-4" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="14" rx="2" fill="#00BAF2"/>
                <text x="20" y="10" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold">Paytm</text>
              </svg>
            </div>

            {/* Razorpay */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <svg className="h-4" viewBox="0 0 48 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="14" rx="2" fill="#0C2451"/>
                <path d="M6 4L10 10L6 10Z" fill="#3395FF"/>
                <text x="14" y="10" fill="white" fontSize="6" fontWeight="600">Razorpay</text>
              </svg>
            </div>

            {/* Bank Transfer */}
            <div className="h-8 px-4 flex items-center justify-center bg-white border border-gray-300 rounded-md shadow-sm hover:shadow-md transition">
              <CreditCard size={14} className="text-gray-600 mr-1.5" />
              <span className="text-gray-700 font-medium text-xs">Bank</span>
            </div>
          </div>
        </div>

        {/* Keval Lens and App Download */}
        <div className="mt-8 pt-8 border-t border-gray-200 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6">
          <div className="flex items-center gap-4 flex-wrap">
            {/* <span className="text-sm text-gray-700">Add <span className="font-semibold">Keval Lens</span> to Chrome</span>
            <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2.5 rounded-lg font-semibold text-sm flex items-center gap-2 transition-all shadow-md hover:shadow-lg">
              <Chrome size={18} />
              <span>Add Keval Lens</span>
            </button> */}
          </div>

          <div className="flex items-center gap-4 flex-wrap">
            {/* <span className="text-sm text-gray-700">Trade on the go with the <span className="font-semibold">Keval.com app</span></span> */}
            <div className="flex gap-2">
              <a href="#" className="block group">
                <div className="bg-black text-white px-4 py-2.5 rounded-lg flex items-center gap-2 hover:bg-gray-800 transition-all shadow-md hover:shadow-lg">
                  <Apple size={24} />
                  <div className="text-left">
                    <div className="text-[10px] leading-tight">Download on the</div>
                    <div className="text-sm font-semibold leading-tight">App Store</div>
                  </div>
                </div>
              </a>
              <a href="#" className="block group">
                <div className="bg-black text-white px-4 py-2.5 rounded-lg flex items-center gap-2 hover:bg-gray-800 transition-all shadow-md hover:shadow-lg">
                  <Smartphone size={24} />
                  <div className="text-left">
                    <div className="text-[10px] leading-tight">GET IT ON</div>
                    <div className="text-sm font-semibold leading-tight">Google Play</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Links */}
      <div className="bg-gray-50 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-6">
          {/* Platform Links */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-sm text-gray-600 mb-4">
            <a href="#" className="hover:text-orange-600">CrossdealGlobal</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">crossdealglobal.com</a>
            {/* <span>|</span>
            <a href="#" className="hover:text-orange-600">Tmall Taobao World</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">Alipay</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">Lazada</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">Taobao Global</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">TAO</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">Trendyol</a>
            <span>|</span>
            <a href="#" className="hover:text-orange-600">Europages</a> */}
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-gray-500">
            <a href="#" className="hover:text-orange-600">Policies and rules</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Legal Notice</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Product Listing Policy</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Intellectual Property Protection</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Privacy Policy</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Terms of Use</a>
            <span>·</span>
            <a href="#" className="hover:text-orange-600">Integrity Compliance</a>
          </div>
        </div>
      </div>
    </footer>
  );
}